<template>
    <div
        class="base-image-input"
        :style="{ 'background-image': `url( ${ imageData[ 0 ] } )` }"
        @click="chooseImage"
    >
        <span
            v-if="!hasImageData"
            class="placeholder"
        >
            {{ placeholder }}
        </span>
        <input
            ref="fileInput"
            class="file-input"
            accept="image/*"
            type="file"
            capture="camera"
            @input="onSelectedFile"
        >
    </div>
</template>

<script>
// MD5 import
import md5 from 'md5';

export default {
    name: 'BaseImageInput',
    props: {
        bgImageData: {
            type: Array,
            required: false,
            default: null,
        },
        placeholder: {
            type: String,
            required: false,
            default: 'Choose an Image',
        },
    },
    data() {
        return {
            imageData: [],
            image: {
                height: '',
                width: '',
                size: '',
            },
        };
    },
    computed: {
        hasImageData() {
            return this.imageData.length > 0;
        },
    },
    mounted() {
        this.setImageData();
    },
    methods: {
        setImageData() {
            this.imageData = this.bgImageData;
        },
        chooseImage() {
            this.$refs.fileInput.click();
        },
        onSelectedFile() {
            // Max sizes and init fields
            const MAX_SIZE = 500000;
            const MAX_HEIGHT = 400;
            const MAX_WIDTH = 400;

            // Get the image info and see if it is too big, if so, then resize
            const input = this.$refs.fileInput;
            const { files } = input;
            if ( files && files[ 0 ] ) {
                const item = files[ 0 ];
                let fType = '';
                let resizedImage;
                const hash = [];
                const index = 0;
                const reader = new FileReader();
                reader.onload = ( e ) => {
                    fType = item.type;
                    this.image.size = item.size;
                    if ( this.image.size > MAX_SIZE ) {
                        const img = new Image();
                        img.src = e.target.result;
                        img.onload = () => {
                            this.imageData[ index ] = e.target.result;
                            this.image.width = img.naturalWidth;
                            this.image.height = img.naturalHeight;
                            if ( ( this.image.width / this.image.height ) > ( MAX_WIDTH / MAX_HEIGHT ) ) {
                                this.image.height *= MAX_WIDTH / this.image.width;
                                this.image.width = MAX_WIDTH;
                            } else {
                                this.image.width *= MAX_HEIGHT / this.image.height;
                                this.image.height = MAX_HEIGHT;
                            }
                            const canvas = document.createElement( 'canvas' );
                            canvas.width = this.image.width;
                            canvas.height = this.image.height;
                            canvas.getContext( '2d' ).drawImage( img, 0, 0, this.image.width, this.image.height );
                            resizedImage = canvas.toDataURL( fType );
                            this.imageData = [];
                            this.imageData[ index ] = resizedImage;
                            hash[ index ] = md5( this.imageData[ index ] );
                            this.$emit( 'savePicture', { image: this.imageData, hash } );
                        };
                    } else {
                        this.imageData = [];
                        this.imageData[ index ] = e.target.result;
                        hash[ index ] = md5( this.imageData[ index ] );
                        this.$emit( 'savePicture', { image: this.imageData, hash } );
                    }
                };
                reader.readAsDataURL( item );
            }
        },
        clearImageData() {
            this.imageData = [];
        },
    },
};
</script>

<style lang="scss" scoped>

.base-image-input {
    display: block;
    width: 25vh;
    height: 25vh;
    cursor: pointer;
    background-size: cover;
    background-position: center center;
}
.placeholder {
    background: #ccc;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--v-anchor-base);;
    text-decoration: underline;
    font-size: 18px;
    font-family: Helvetica,serif;
}
.placeholder:hover {
    background: #E0E0E0;
}
.file-input {
    display: none;
}
</style>
